import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ProductDashboardSummaryModel } from "src/app/core/models/product-model/product-dashboard-model/product-dashboard-summary.model";
import { PRODUCT_DASHBOARD_SPECIALSERVICE_SUMMARY_DEMO } from "./product-dashboard-specialservice-summary-demo-data";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-dashboard-specialservice-summary.component.html',
    selector: 'op-product-dashboard-specialservice-summary'
})
export class ProductDashboardSpecialServiceSummaryComponent implements AfterViewInit {
    public summaryResultInfo: ProductDashboardSummaryModel[];

    constructor(private changeDetection: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.loadData();
    }

    private loadData() {
        setTimeout(() => {
            this.summaryResultInfo = PRODUCT_DASHBOARD_SPECIALSERVICE_SUMMARY_DEMO;
            this.changeDetection.detectChanges();
        }, 500);
    }
}